import { IColumn } from '@features/General'
import CloseLineIcon from 'remixicon-react/CloseLineIcon'
import CheckLineIcon from 'remixicon-react/CheckLineIcon'
import SecurePaymentLineIcon from 'remixicon-react/SecurePaymentLineIcon'
import { SubscriptionOrderStatusColors, SubscriptionOrderStatus } from '../index'
import store from '@store/store'
import { rootActions } from '@app-store/slices'
import { history } from '@components/App'
import routes from '@utils/constants/routes'

export const listColumns = (i18n, userId, appDirection): IColumn[] => [
    {
        title: i18n?.General?.Company,
        dataIndex: 'company',
        type: 'nested',
        fields: ['name'],
        allowHide: true
    },
    {
        title: 'Plan Name',
        dataIndex: 'subscriptionName',
        key: 'subscription',
        type: 'nested',
        fields: ['name'],
        allowHide: true
    },
    {
        title: 'Price',
        dataIndex: 'price',
        allowHide: true
    },
    {
        title: 'User',
        dataIndex: 'user',
        type: 'nested',
        fields: ['firstname', 'lastname'],
        allowHide: true
    },
    {
        title: 'Max Subscribers',
        dataIndex: 'subscriptionMaxSubscribers',
        key: 'subscription',
        type: 'nested',
        fields: ['maxSubscribers'],
        allowHide: true
    },
    {
        title: 'Points',
        dataIndex: 'subscriptionPoints',
        key: 'subscription',
        type: 'nested',
        fields: ['points'],
        allowHide: true
    },
    {
        title: i18n?.General?.Status,
        dataIndex: 'orderStatus',
        key: 'status',
        type: 'badge',
        bg: value => SubscriptionOrderStatusColors[value],
        align: appDirection === 'rtl' ? 'right' : 'left'
    },
    {
        title: 'Approved date',
        dataIndex: 'approvedAt',
        type: 'dateTime',
        format: 'DD.MM.YYYY',
        allowHide: true,
        sorter: true
    },
    {
        dataIndex: 'actions',
        type: 'actions',
        actions: record => [
            {
                title: i18n?.General?.Cancel,
                icon: CloseLineIcon,
                key: 'cancel',
                abilityAction: 'EditOrder',
                abilityService: 'Subscription',
                hide:
                    record.user._id !== userId ||
                    ![SubscriptionOrderStatus.PENDING, SubscriptionOrderStatus.WAITING].includes(record.status),
                onClick: record =>
                    store.dispatch(
                        rootActions.orders.cancel.onRequest({
                            id: record._id
                        })
                    )
            },
            {
                title: 'Pay',
                icon: SecurePaymentLineIcon,
                key: 'pay',
                hide: record.user._id !== userId || record.status !== SubscriptionOrderStatus.PENDING,
                onClick: record => history.push(routes.settings.account.orders.payment._.replace(':id', record._id))
            },
            {
                title: 'Approve',
                icon: CheckLineIcon,
                key: 'approve',
                abilityAction: 'ApproveOrder',
                abilityService: 'Subscription',
                hide: record.status !== SubscriptionOrderStatus.WAITING,
                onClick: record => store.dispatch(rootActions.orders.approve.onRequest({ id: record._id }))
            },
            {
                title: i18n?.General?.Reject,
                icon: CloseLineIcon,
                key: 'reject',
                abilityAction: 'RejectOrder',
                abilityService: 'Subscription',
                hide: record.status !== SubscriptionOrderStatus.WAITING,
                onClick: record => store.dispatch(rootActions.orders.reject.onRequest({ id: record._id }))
            }
        ]
    }
]
